import Config from '../../services/config/config';

const CHECKOUT_IFRAME_REGEX =
  /https:\/\/services-checkout-security(\.[a-z0-9-]+)?\.nubestaging\.com/;

const matchStagingDomain = (origin: string): boolean => CHECKOUT_IFRAME_REGEX.test(origin);

const isSecurityCheckoutOrigin = (origin: string) =>
  origin === Config.CHECKOUT_SECURITY_HOST ||
  (Config.ENV !== 'production' && matchStagingDomain(origin));

export default isSecurityCheckoutOrigin;
